import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import Slider from 'react-slick';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { DesktopImage, ImageInfoContainer, IndividualSlideWrapper, LogoImage, MobileImage, SliderWrapper } from './ClientShowCase.pro.styles';

interface ClientShowCaseProps {
  cases: {
    desktopImage: { gatsbyImageData: IGatsbyImageData };
    mobileImage: { gatsbyImageData: IGatsbyImageData };
    logo: { gatsbyImageData: IGatsbyImageData };
    title: string;
    description: string;
  }[];
}

const ClientShowCase = ({ cases }: ClientShowCaseProps): JSX.Element => {
  const imageElements = cases.map(({ desktopImage, mobileImage, logo, description, title }, index) => (
    <IndividualSlideWrapper key={title}>
      <DesktopImage>
        <Image childImageSharp={desktopImage.gatsbyImageData} alt={`slide ${index}`} />
      </DesktopImage>

      <ImageInfoContainer>
        <LogoImage>
          <Image childImageSharp={logo.gatsbyImageData} alt={`slide ${index} logo`} />
        </LogoImage>

        <Heading text={title} size="32px" sizeMd="18px" level={2} />
        <Paragraph text={description} size="22px" sizeMd="14px" weight="light" />
      </ImageInfoContainer>

      <MobileImage >
        <Image childImageSharp={mobileImage.gatsbyImageData} alt={`slide ${index} mobile`} />
      </MobileImage >
    </IndividualSlideWrapper>
  ));


  return (
    <SliderWrapper>
      <Slider
        dots={true}
        infinite={true}
        speed={300}
        arrows={false}
        autoplaySpeed={4500}
        autoplay
        pauseOnDotsHover
        pauseOnFocus
      >
        {imageElements}
      </Slider>
    </SliderWrapper>
  )
}

export default ClientShowCase;
